import chatIcon from "../../assets/chat.svg";
import phoneIcon from "../../assets/phone-icon.svg";
import eyeIcon from "../../assets/eye.svg";
import supportIcon from "../../assets/support.svg";
import penIcon from "../../assets/pen-design.svg";
import unlimiterIcon from "../../assets/unlimiter.svg";
import iphone from "../../assets/iphone.png";
import bg from "../../assets/about-img.png";
import "./style.css";

const Features = () => {
	const data = [
		{
			icon: chatIcon,
			label: "Full free chat",
			description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
		},
		{
			icon: phoneIcon,
			label: "iso & androind version",
			description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
		},
		{
			icon: eyeIcon,
			label: "retina ready greaphics",
			description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
		},
		{
			icon: supportIcon,
			label: "24/7 support by real pepole",
			description: "In-app customer support chat or call feature.",
		},
		{
			icon: penIcon,
			label: "awsome ui design",
			description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
		},
		{
			icon: unlimiterIcon,
			label: "unlimiter features",
			description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
		},
	];

	return (
		<div className="features" id="Features">
			<div className="container">
				<p className="title">App features</p>
				<p className="description">
					Book a valet before arriving at your destination. Real-time valet
					availability and estimated arrival time.
				</p>
				<div className="features-data">
					<div className="row position-relative">
						<div className="col-lg-12 col-md-6 order1">
							{data?.length >= 0 && (
								<div className="feature-card w-100 mb-5 text-center">
									<img src={data[0].icon} alt="icon" />
									<div>
										<p className="title">{data[0].label}</p>
										{/* <p className="description">{data[0].description}</p> */}
									</div>
								</div>
							)}
						</div>
						<div className="col-lg-4 col-md-6 order2">
							<div className="h-100 py-5 px-3 d-flex flex-column justify-content-between align-items-end">
								{data?.length >= 5 && (
									<div className="feature-card text-end">
										<img src={data[5].icon} alt="icon" />
										<div>
											<p className="title text-end">{data[5].label}</p>
											{/* <p className="description text-end">
												{data[5].description}
											</p> */}
										</div>
									</div>
								)}
								{data?.length >= 4 && (
									<div className="feature-card text-end">
										<img src={data[4].icon} alt="icon" />
										<div>
											<p className="title text-end">{data[4].label}</p>
											{/* <p className="description text-end">
												{data[4].description}
											</p> */}
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="col-lg-4 col-md-6 order3">
							<div className="iphone-card">
								<img src={iphone} className="iphone" alt="iphone" />
								<img src={bg} className="bg" alt="bg" />
							</div>
						</div>
						<div className="col-lg-4 col-md-6 order4">
							<div className="h-100 py-5 px-3 d-flex flex-column justify-content-between align-items-start">
								{data?.length >= 1 && (
									<div className="feature-card text-start">
										<img src={data[1].icon} alt="icon" />
										<div>
											<p className="title text-start">{data[1].label}</p>
											{/* <p className="description text-start">
												{data[1].description}
											</p> */}
										</div>
									</div>
								)}
								{data?.length >= 2 && (
									<div className="feature-card text-start">
										<img src={data[2].icon} alt="icon" />
										<div>
											<p className="title text-start">{data[2].label}</p>
											{/* <p className="description text-start">
												{data[2].description}
											</p> */}
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="col-lg-12 col-md-6  order5">
							{data?.length >= 3 && (
								<div className="feature-card w-100 mt-5 text-center">
									<img src={data[3].icon} alt="icon" />
									<div>
										<p className="title">{data[3].label}</p>
										{/* <p className="description">{data[3].description}</p> */}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Features;
